import VideoComment from ".";


export const videoCommentRoutes = () => [
  {
    path: "/admin/video-comments",
    component: VideoComment,
    layout: "admin",
    routeType: "admin",
    title: "Blogs Management",
  },
];
